<mat-menu #menu="matMenu">
  <button mat-menu-item disabled>v. {{version}}</button>
  <mat-divider></mat-divider>
  <button mat-menu-item routerLink="/reserved/profile">Profile</button>
  <mat-divider></mat-divider>
  <ng-container *awIsInAnyRole="[roles.researcher]">
    <button mat-menu-item routerLink="/reserved/client-download">Download Client</button>
    <mat-divider></mat-divider>
  </ng-container>
  <button (click)="logout()" mat-menu-item>Logout</button>
</mat-menu>


<div class="h-100-vh private-container" fxLayout="column" fxLayoutAlign="start">

  <mat-toolbar color="primary">
    <button (click)="sidenav.toggle()" *awIsInAnyRole="[roles.admin, roles.customer, roles.logistic, roles.tester]"
      aria-label="Example icon-button with menu icon" class="example-icon" mat-icon-button>
      <mat-icon>menu</mat-icon>
    </button>
    <a class="h-100" fxLayout="column" fxLayoutAlign="center center" routerLink="/reserved">
      <img class="toolbar-img-height" src="assets/weseth-logo-trans.png">
    </a>
    <span fxFlex></span>
    <ng-container *awIsAuthenticated="true">
      <button [matMenuTriggerFor]="menu" mat-flat-button>
        <ng-container *ngIf="loggedUser?.lastName && loggedUser?.firstName">{{loggedUser?.firstName}}
          {{loggedUser?.lastName}}
        </ng-container>
        <ng-container *ngIf="!loggedUser?.lastName || !loggedUser?.firstName">{{loggedUser?.email}}</ng-container>
      </button>

      <aw-notifications class="w-max-100-vw"></aw-notifications>

    </ng-container>
    <button mat-icon-button matTooltip="Change theme" (click)="changeTheme()" class="mr-8">
      <ng-container *ngIf="darkTheme">
        <mat-icon>bedtime</mat-icon>
      </ng-container>
      <ng-container *ngIf="!darkTheme">
        <mat-icon>brightness_5</mat-icon>
      </ng-container>
    </button>
  
  </mat-toolbar>

  <!-- <mat-sidenav-container fxFlex> -->
  <mat-sidenav-container [ngClass]="{'darkBackground': darkTheme, 'lightBackground': !darkTheme}" fxFlex>

    <mat-sidenav #sidenav [opened]="[roles.admin, roles.customer, roles.logistic, roles.tester].includes(loggedUser!.role!)"
      mode="side">

      <div class="h-100" fxLayout="column">
        <mat-accordion fxFlex>

          <mat-expansion-panel #rlaUsers="routerLinkActive" [expanded]="isActive('/reserved/users')"
            class="mat-elevation-z0" routerLinkActive>
            <mat-expansion-panel-header *awIsInAnyRole="[roles.admin, roles.customer, roles.tester]"
              [class]="{ 'color-primary': rlaUsers.isActive} ">
              Users
            </mat-expansion-panel-header>
            <mat-nav-list>
              <mat-list-item *awIsInAnyRole="[roles.admin]" [routerLinkActive]="'color-primary'"
                routerLink="/reserved/users/admins">
                Administrators
              </mat-list-item>
              <mat-list-item *awIsInAnyRole="[roles.admin]" [routerLinkActive]="'color-primary'"
                routerLink="/reserved/users/customers">
                Customers
              </mat-list-item>
              <mat-list-item *awIsInAnyRole="[roles.admin, roles.customer]" [routerLinkActive]="'color-primary'"
                routerLink="/reserved/users/researchers">
                Researchers
              </mat-list-item>
              <mat-list-item *awIsInAnyRole="[roles.admin]" [routerLinkActive]="'color-primary'"
                routerLink="/reserved/users/logistics">
                Logistics
              </mat-list-item>
              <mat-list-item *awIsInAnyRole="[roles.admin, roles.customer, roles.tester]" [routerLinkActive]="'color-primary'"
                routerLink="/reserved/users/testers">
                Testers
              </mat-list-item>
            </mat-nav-list>
          </mat-expansion-panel>

          <mat-expansion-panel #rlaCompanies="routerLinkActive" *awIsInAnyRole="[roles.admin]"
            [expanded]="isActive('/reserved/companies')" class="mat-elevation-z0" routerLinkActive>
            <mat-expansion-panel-header *awIsInAnyRole="[roles.admin]"
              [class]="{ 'color-primary': rlaCompanies.isActive} ">
              Companies
            </mat-expansion-panel-header>
            <mat-nav-list>
              <mat-list-item *awIsInAnyRole="[roles.admin]" [routerLinkActive]="'color-primary'"
                routerLink="/reserved/companies">
                All Companies
              </mat-list-item>

            </mat-nav-list>
          </mat-expansion-panel>

          <mat-expansion-panel #rlaStorage="routerLinkActive" *awIsInAnyRole="[roles.admin]"
            [expanded]="isActive('/reserved/storage')" class="mat-elevation-z0" routerLinkActive>
            <mat-expansion-panel-header *awIsInAnyRole="[roles.admin]"
              [class]="{ 'color-primary': rlaStorage.isActive} ">
              Storage
            </mat-expansion-panel-header>
            <mat-nav-list>
              <mat-list-item *awIsInAnyRole="[roles.admin]" [routerLinkActive]="'color-primary'"
                routerLink="/reserved/storage">
                Storage
              </mat-list-item>
            </mat-nav-list>
          </mat-expansion-panel>

          <mat-expansion-panel #rlaCertificates="routerLinkActive" *awIsInAnyRole="[roles.admin]"
            [expanded]="isActive('/reserved/certificates')" class="mat-elevation-z0" routerLinkActive>
            <mat-expansion-panel-header *awIsInAnyRole="[roles.admin]"
              [class]="{ 'color-primary': rlaCertificates.isActive} ">
              Certificates
            </mat-expansion-panel-header>
            <mat-nav-list>
              <mat-list-item *awIsInAnyRole="[roles.admin]" [routerLinkActive]="'color-primary'"
                routerLink="/reserved/certificates/box-certificates">
                Box Certificates
              </mat-list-item>
              <mat-list-item *awIsInAnyRole="[roles.admin]" [routerLinkActive]="'color-primary'"
                routerLink="/reserved/certificates/researcher-certificates">
                Researcher Certificates
              </mat-list-item>
            </mat-nav-list>
          </mat-expansion-panel>

          <mat-expansion-panel #rlaContracts="routerLinkActive"
            *awIsInAnyRole="[roles.admin, roles.customer, roles.logistic]" [expanded]="isActive('/reserved/admins')"
            class="mat-elevation-z0" routerLinkActive>
            <mat-expansion-panel-header *awIsInAnyRole="[roles.admin, roles.customer, roles.logistic, roles.tester]"
              [class]="{ 'color-primary': rlaContracts.isActive} ">
              Contracts
            </mat-expansion-panel-header>
            <mat-nav-list>
              <mat-list-item *awIsInAnyRole="[roles.admin, roles.customer, roles.logistic, roles.tester]"
                [routerLinkActive]="'color-primary'" routerLink="/reserved/contracts">
                All Contracts
              </mat-list-item>
            </mat-nav-list>
          </mat-expansion-panel>


          <mat-expansion-panel #rlaTestbeds="routerLinkActive" *awIsInAnyRole="[roles.admin, roles.customer]"
            [expanded]="isActive('/reserved/testbeds')" class="mat-elevation-z0" routerLinkActive>
            <mat-expansion-panel-header *awIsInAnyRole="[roles.admin, roles.customer]"
              [class]="{ 'color-primary': rlaTestbeds.isActive} ">
              Testbeds
            </mat-expansion-panel-header>
            <mat-nav-list>
              <mat-list-item *awIsInAnyRole="[roles.admin, roles.customer]" [routerLinkActive]="'color-primary'"
                routerLink="/reserved/testbeds">
                Testbeds
              </mat-list-item>
            </mat-nav-list>
          </mat-expansion-panel>

          <mat-expansion-panel #rlaTestbeds="routerLinkActive" *awIsInAnyRole="[roles.admin, roles.customer, roles.tester]"
            [expanded]="isActive('/reserved/companies/execute')" class="mat-elevation-z0" routerLinkActive>
            <mat-expansion-panel-header *awIsInAnyRole="[roles.admin, roles.customer, roles.tester]"
              [class]="{ 'color-primary': rlaTestbeds.isActive} ">
              Execute Test
            </mat-expansion-panel-header>
            <mat-nav-list>
              <mat-list-item *awIsInAnyRole="[roles.admin, roles.customer, roles.tester]" [routerLinkActive]="'color-primary'"
                routerLink="/reserved/companies/execute">
                Execute Test
              </mat-list-item>
            </mat-nav-list>
          </mat-expansion-panel>

          <mat-expansion-panel #rlaTestbeds="routerLinkActive" *awIsInAnyRole="[roles.admin, roles.customer]"
            [expanded]="isActive('/reserved/test-image')" class="mat-elevation-z0" routerLinkActive>
            <mat-expansion-panel-header *awIsInAnyRole="[roles.admin, roles.customer]"
              [class]="{ 'color-primary': rlaTestbeds.isActive} ">
              Upload Test
            </mat-expansion-panel-header>
            <mat-nav-list>
              <mat-list-item *awIsInAnyRole="[roles.admin, roles.customer]" [routerLinkActive]="'color-primary'"
                routerLink="/reserved/test-image">
                Upload Test
              </mat-list-item>
            </mat-nav-list>
          </mat-expansion-panel>

          <mat-expansion-panel #rlaDiagnostics="routerLinkActive" *awIsInAnyRole="[roles.admin, roles.customer]"
            [expanded]="isActive('/reserved/diagnostics')" class="mat-elevation-z0" routerLinkActive>
            <mat-expansion-panel-header *awIsInAnyRole="[roles.admin, roles.customer]"
              [class]="{ 'color-primary': rlaDiagnostics.isActive} ">
              Diagnostics
            </mat-expansion-panel-header>
            <!-- <mat-expansion-panel #rlaServerLog="routerLinkActive"
                        *awIsInAnyRole="[roles.admin]"
                        [expanded]="isActive('/reserved/diagnostics/server-logs')"
                        class="mat-elevation-z0" routerLinkActive>
              <mat-expansion-panel-header *awIsInAnyRole="[roles.admin]"
                        [class]="{ 'color-primary': rlaServerLog.isActive} ">
              Server logs
              </mat-expansion-panel-header>                 
              <mat-nav-list>
              <mat-list-item *awIsInAnyRole="[roles.admin]" [routerLinkActive]="'color-primary'"
                      routerLink="/reserved/diagnostics/server-logs/system-logs" style="font-size: 14px;">
              System logs
              </mat-list-item>
              <mat-list-item *awIsInAnyRole="[roles.admin]" [routerLinkActive]="'color-primary'"
                      routerLink="/reserved/diagnostics/server-logs/connection-logs" style="font-size: 14px;">
              Connection Logs
              </mat-list-item>
              <mat-list-item *awIsInAnyRole="[roles.admin]" [routerLinkActive]="'color-primary'"
                      routerLink="/reserved/diagnostics/server-logs/operation-logs" style="font-size: 14px;">
              Operation Logs
              </mat-list-item>
              </mat-nav-list>
              </mat-expansion-panel> -->
            <!-- <mat-expansion-panel #rlaServerLog="routerLinkActive"
                        *awIsInAnyRole="[roles.admin]"
                        [expanded]="isActive('/reserved/diagnostics/box-logs')"
                        class="mat-elevation-z0" routerLinkActive>
              <mat-expansion-panel-header *awIsInAnyRole="[roles.admin]"
                        [class]="{ 'color-primary': rlaServerLog.isActive} ">
              Box logs
              </mat-expansion-panel-header>                  -->
            <mat-nav-list>
              <!-- <mat-list-item *awIsInAnyRole="[roles.admin]" [routerLinkActive]="'color-primary'"
                      routerLink="/reserved/diagnostics/box-logs/interface-logs" style="font-size: 14px;">
              Interface Logs
              </mat-list-item>
              <mat-list-item *awIsInAnyRole="[roles.admin]" [routerLinkActive]="'color-primary'"
                      routerLink="/reserved/diagnostics/box-logs/update-logs" style="font-size: 14px;">
              Update Logs
              </mat-list-item>
              <mat-list-item *awIsInAnyRole="[roles.admin]" [routerLinkActive]="'color-primary'"
                      routerLink="/reserved/diagnostics/box-logs/result-update-logs" style="font-size: 14px;">
              Update Result Logs
              </mat-list-item> -->
              <mat-list-item *awIsInAnyRole="[roles.admin, roles.customer]" [routerLinkActive]="'color-primary'"
                routerLink="/reserved/diagnostics/box-logs" style="font-size: 14px;">
                Box Logs
              </mat-list-item>
              <!-- <mat-list-item *awIsInAnyRole="[roles.admin]" [routerLinkActive]="'color-primary'"
                      routerLink="/reserved/diagnostics/box-logs/tampering-attempt-logs" style="font-size: 14px;">
              Tampering Attempt Logs
              </mat-list-item> -->
            </mat-nav-list>
            <!-- </mat-expansion-panel> -->
          </mat-expansion-panel>

          <mat-expansion-panel #rlaBoxesManagement="routerLinkActive" *awIsInAnyRole="[roles.admin, roles.logistic]"
            [expanded]="isActive('/reserved/boxes-management')" class="mat-elevation-z0" routerLinkActive>
            <mat-expansion-panel-header *awIsInAnyRole="[roles.admin, roles.logistic]"
              [class]="{ 'color-primary': rlaBoxesManagement.isActive} ">
              Boxes
            </mat-expansion-panel-header>
            <mat-nav-list>
              <mat-list-item *awIsInAnyRole="[roles.admin, roles.logistic]" [routerLinkActive]="'color-primary'"
                routerLink="/reserved/boxes-management/boxes">
                Boxes
              </mat-list-item>
              <mat-list-item *awIsInAnyRole="[roles.admin, roles.logistic]" [routerLinkActive]="'color-primary'"
                routerLink="/reserved/boxes-management/sims">
                Sims
              </mat-list-item>
              <mat-list-item *awIsInAnyRole="[roles.admin, roles.logistic]" [routerLinkActive]="'color-primary'"
                routerLink="/reserved/boxes-management/interfaces">
                Interfaces
              </mat-list-item>
            </mat-nav-list>
          </mat-expansion-panel>
          <mat-expansion-panel #rlaInvoices="routerLinkActive" *awIsInAnyRole="[roles.admin, roles.customer]"
            [expanded]="isActive('/reserved/invoices')" class="mat-elevation-z0" routerLinkActive>
            <mat-expansion-panel-header *awIsInAnyRole="[roles.admin, roles.customer]"
              [class]="{ 'color-primary': rlaInvoices.isActive} ">
              Invoice management
            </mat-expansion-panel-header>
            <mat-nav-list>
              <mat-list-item *awIsInAnyRole="[roles.admin]" [routerLinkActive]="'color-primary'"
                routerLink="/reserved/invoices/invoices-setup">
                Setup
              </mat-list-item>
              <mat-list-item *awIsInAnyRole="[roles.admin, roles.customer]" [routerLinkActive]="'color-primary'"
                routerLink="/reserved/invoices/invoices-items">
                Items
              </mat-list-item>
            </mat-nav-list>
          </mat-expansion-panel>
          <mat-expansion-panel #rlaBilling="routerLinkActive" *awIsInAnyRole="[roles.admin, roles.customer]"
            [expanded]="isActive('/reserved/billing')" class="mat-elevation-z0" routerLinkActive>
            <mat-expansion-panel-header *awIsInAnyRole="[roles.admin, roles.customer]"
              [class]="{ 'color-primary': rlaBilling.isActive} ">
              Billing management
            </mat-expansion-panel-header>
            <mat-nav-list>
              <mat-list-item *awIsInAnyRole="[roles.admin]" [routerLinkActive]="'color-primary'"
                routerLink="/reserved/billing/setup">
                Setup
              </mat-list-item>
              <mat-list-item *awIsInAnyRole="[roles.admin, roles.customer]" [routerLinkActive]="'color-primary'"
                routerLink="/reserved/billing/items">
                Items
              </mat-list-item>
            </mat-nav-list>
          </mat-expansion-panel>


          <!--          <mat-expansion-panel #rlaInvoices="routerLinkActive"-->
          <!--                               *awIsInAnyRole="[roles.admin]"-->
          <!--                               [expanded]="isActive('/reserved/invoices')"-->
          <!--                               class="mat-elevation-z0" routerLinkActive>-->
          <!--            <mat-expansion-panel-header *awIsInAnyRole="[roles.admin]"-->
          <!--                                        [class]="{ 'color-primary': rlaInvoices.isActive} ">-->
          <!--              Invoices-->
          <!--            </mat-expansion-panel-header>-->
          <!--          </mat-expansion-panel>-->

          <!--          <mat-expansion-panel #rlaBilling="routerLinkActive"-->
          <!--                               *awIsInAnyRole="[roles.admin]"-->
          <!--                               [expanded]="isActive('/reserved/billing')"-->
          <!--                               class="mat-elevation-z0" routerLinkActive>-->
          <!--            <mat-expansion-panel-header *awIsInAnyRole="[roles.admin]"-->
          <!--                                        [class]="{ 'color-primary': rlaBilling.isActive} ">-->
          <!--              Billing setup-->
          <!--            </mat-expansion-panel-header>-->
          <!--            <mat-nav-list>-->
          <!--              <mat-list-item *awIsInAnyRole="[roles.admin]" [routerLinkActive]="'color-primary'"-->
          <!--                             routerLink="/reserved/billing/setup">-->
          <!--                Setup-->
          <!--              </mat-list-item>-->
          <!--              <mat-list-item *awIsInAnyRole="[roles.admin]" [routerLinkActive]="'color-primary'"-->
          <!--                             routerLink="/reserved/billing/items">-->
          <!--                Items-->
          <!--              </mat-list-item>-->
          <!--            </mat-nav-list>-->
          <!--          </mat-expansion-panel>-->

          <!--          <mat-expansion-panel #rlaNotifications="routerLinkActive"-->
          <!--                               *awIsInAnyRole="[roles.admin]"-->
          <!--                               [expanded]="isActive('/reserved/notiications')"-->
          <!--                               class="mat-elevation-z0" routerLinkActive>-->
          <!--            <mat-expansion-panel-header *awIsInAnyRole="[roles.admin]"-->
          <!--                                        [class]="{ 'color-primary': rlaNotifications.isActive} ">-->
          <!--              Notifications-->
          <!--            </mat-expansion-panel-header>-->
          <!--          </mat-expansion-panel>-->


        </mat-accordion>

        <ng-container *ngIf="isKeycloak">
          <a class="bottom-link" href="https://beian.miit.gov.cn/" target="_blank">京ICP备2024060014号-4</a>
        </ng-container>

      </div>
    </mat-sidenav>

    <mat-sidenav-content>
      <div class="ph-2_5 pv-1">
        <router-outlet></router-outlet>
      </div>
    </mat-sidenav-content>

  </mat-sidenav-container>

</div>